import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import TideForm from './TideForm';
import ReactGA from '../../utils/analytics';

class TideForms extends React.Component {
  constructor() {
    super();

    this.state = {
      selectedIndex: 0
    }
  }

  componentDidMount() {
    // Collect data for Google Analytics
    ReactGA.event({
      category: 'Browsing Tide Form Exercises',
      action: 'Tide Form Exercises Page'
    });
  }

  getTabs() {
    const { data } = this.props;

    return data
      .filter(exercise => exercise.tideform_published !== false)
      .map((exercise, index) => ({
        name: `${index}`,
        title: exercise.tideform_tab_title || `Exercise ${index + 1}`,
        data: exercise
      }));
  }

  render() {
    const tabs = this.getTabs();
    if (tabs.length === 0) return null;

    const { selectedIndex } = this.state;
    const activeTab = tabs[selectedIndex] || tabs[0];
    const storageKey = `tideform_${activeTab.data.tabGroup || 'default'}_${activeTab.name}`;

    return (
      <div className="mt-4">
        <Nav tabs className="wp-tab-panel">
          {tabs.map((tab, index) => (
            <NavItem key={tab.name}>
              <NavLink
                active={index === selectedIndex}
                className={index === selectedIndex ? 'active-tab' : ''}
                onClick={() => this.setState({ selectedIndex: index })}
              >
                {tab.title}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TideForm key={storageKey} {...activeTab.data} storageKey={storageKey} />
      </div>
    );
  }
}

export default TideForms;
